<template>
  <div :class="cssClass">
    <div v-if="def.inputType">
      <span v-if="def.lookup">
        <AbrFormPropReadOnly v-if="$attrs.readonly" v-bind="getAttrs()" />
        <AppTreeSelect
          v-else-if="
            def.inputType &&
            def.inputType.name === 'ECore.Def.DefEnums.itTreeSelect'
          "
          :value-consists-of="valueConsistsOf"
          :value="
            def.foreignProperty
              ? value && value.map((i) => i[def.foreignProperty])
              : value
          "
          :options="ConvertToTree(lookupItems)"
          :normalizer="normalizer"
          :placeholder="$t(def)"
          @input="
            value =
              $event && def.foreignProperty
                ? $event.map((i) => ({ [def.foreignProperty]: i }))
                : $event
          "
        />
        <component
          :is="componentType"
          v-else
          v-bind="getAttrs()"
          v-model="model[def.name]"
          v-on="getListeners()"
        />
      </span>
    </div>
  </div>
</template>

<script>
import AbrFormPropReadOnly from "@/components/form/AbrFormPropReadOnly";
import AppTreeSelect from "../library/inputFields/AppTreeSelect";
import debounce from "@/utils/debounce";

export default {
  name: "AbrFormPropLookup",
  components: {
    AppTreeSelect,
    AbrFormPropReadOnly,
  },
  props: ["def", "model"],
  data: function () {
    return {
      inputEvents: {},
      lookupItems: [],
      Model: this.model,
      cascadeProp: undefined,
      sortProp: undefined,
      value: undefined,
      filterValue: undefined,
      cssClass: "py-1",
      debounceInputLookup: debounce(this.inputLookup, 800),
      // debounceFetchLookupItems: debounce(this.fetchLookupItems, 1000)
      // debounceProcessChange: this.debounceServerLookupRequest(() =>
      //   this.inputLookup()
      // ),
    };
  },
  computed: {
    componentType() {
      const type = this.def.inputType.name.split(".").pop();
      switch (type) {
        case "itSelect":
          if (this.def.displayConvertType)
            return () =>
              import("@/components/library/inputFields/AppConverterTextField");
          return () => import("@/components/library/inputFields/AppSelectBox");
        case "itMultiSelect":
          return () => import("@/components/library/inputFields/AppSelectBox");
        case "itAutoComplete":
          return () =>
            import("@/components/library/inputFields/AppAutoComplete");
        case "itMultiAutoComplete":
          return () =>
            import("@/components/library/inputFields/AppAutoComplete");
        case "itMultiCheckbox":
          return () => import("@/components/library/inputFields/AppCheckBox");
        case "itMultiRadio":
          return () =>
            import("@/components/library/inputFields/AppMultiRadioButton");
        case "itRadio":
          return () =>
            import("@/components/library/inputFields/AppRadioButton");
        case "itSwitch":
          return () => import("@/components/library/inputFields/AppSwitch");
        case "itExtSwitch":
          return () => import("@/components/library/inputFields/AppExtSwitch");
        case "itRiskIdSelector":
          return () =>
            import("@/components/library/inputFields/AppRiskIdSelector");
        default:
          return () => import("@/components/library/inputFields/AppTextField");
      }
    },
    valueConsistsOf() {
      return "LEAF_PRIORITY";
    },
    LookupItems() {
      let items = [...this.lookupItems];
      if (this.cascadeProp)
        items = items?.filter(
          (i) =>
            !this.cascadeProp ||
            i.CascadeValue === this.Model[this.cascadeProp] ||
            !i.CascadeValue,
        );
      else if (this.sortProp)
        items?.unshift(
          ...this.lookupItems.filter(
            (i) => !this.sortProp || i.SortValue === this.Model[this.sortProp],
          ),
        );
      return items;
    },
  },
  async mounted() {
    const form = this.def.panel?.section?.page?.form;
    this.sortProp =
      this.def.lookup &&
      this.def.lookupSort &&
      this.loopOverFormProps(form, this.def.lookupSort.name);
    this.cascadeProp =
      this.def.lookup &&
      this.def.lookupCascade &&
      this.loopOverFormProps(form, this.def.lookupCascade.name);
    if (this.def.lookup) {
      await this.fetchLookupItems(undefined, this.Model[this.def.name]);
    }
    this.$watch(
      "Model",
      async () => {
        if (this.def.filterValue) {
          const val = await this.$eval(this.def.filterValue);
          const matches = (obj, source) =>
            Object.keys(source).every(
              // eslint-disable-next-line no-prototype-builtins
              (key) => obj.hasOwnProperty(key) && obj[key] === source[key],
            );
          if (
            [val, this.filterValue].every((i) => typeof i === "object") &&
            matches(this.filterValue, val)
          ) {
            return;
          }
          this.filterValue = val;
        }
      },
      { immediate: true, deep: true },
    );
    // TODO
    this.$watch("filterValue", async () => {
      await this.fetchLookupItems(undefined, this.Model[this.def.name]);
      this.def.lookup &&
        this.def.lookup.additionalFields &&
        this.fillAdditional(
          this.lookupItems.find((l) => l.ID === this.Model[this.def.name]),
          true,
        );
    });
    this.$watch(
      `Model.${this.def.name}`,
      async (nv, ov) => {
        // this.value = this.Model[this.def.name];

        if (
          this.def.lookup?.lookupMethod?.name ===
          "ECore.Def.DefEnums.lmServerAutoComplete"
        ) {
          nv && (await this.fetchLookupItems(undefined, nv));
          this.def.lookup &&
            this.def.lookup.additionalFields &&
            this.fillAdditional(
              this.lookupItems.find((l) => l.ID === nv),
              ov === undefined,
            );
        }
      },
      { immediate: true },
    );
    // this.$watch(
    //   "value",
    //   (nv) => {
    //     this.$nextTick(() => this.$set(this.Model, this.def.name, nv));
    //   },
    //   { immediate: false }
    // );
    this.$watch(`Model.${this.cascadeProp}`, () => {
      this.$nextTick(() => {
        if (!(this.def.name in this.Model.__proxy__.originalValues))
          // this.value = undefined;
          this.$set(this.Model, this.def.name, undefined);
      });
    });
  },
  created() {
    // console.log('AbrFormPropLookUp ' , this.def.name , ' cssClass :>> ' , this.def.cssClass);
    if (this.def.cssClass) {
      this.cssClass = "py-1 " + this.def.cssClass;
    } else {
      this.cssClass = "py-1";
    }
    this.$watch("def.cssClass", (nv) => {
      if (nv) {
        this.cssClass = "py-1 " + nv;
      } else {
        this.cssClass = "py-1";
      }
    });
  },
  methods: {
    getAttrs() {
      const attrs = {
        ...this.$attrs,
        ...this._props,
        // items: this.LookupItems
        items: this.LookupItems.map((li) => ({
          ID: li?.ID,
          DisplayText: this.$t(li?.DisplayText),
        })),
      };
      const type = this.def.inputType.name.split(".").pop();
      switch (type) {
        case "itSelect":
          return attrs;
        case "itMultiSelect":
          return {
            ...attrs,
            multiple: true,
            chips: true,
            deletableChips: true,
            smallChips: true,
          };
        case "itAutoComplete":
          if (
            this.def.lookup.lookupMethod?.name ===
            "ECore.Def.DefEnums.lmServerAutoComplete"
          ) {
            return { ...attrs, "prepend-inner-icon": "mdi-magnify" };
          }
          return attrs;
        case "itRiskIdSelector":
          if (
            this.def.lookup.lookupMethod?.name ===
            "ECore.Def.DefEnums.lmServerAutoComplete"
          ) {
            return { ...attrs, "prepend-inner-icon": "mdi-magnify" };
          }
          return attrs;
        case "itMultiAutoComplete":
          return {
            ...attrs,
            multiple: true,
            chips: true,
            deletableChips: true,
            smallChips: true,
          };
        case "itMultiCheckbox":
          return attrs;
        case "itMultiRadio":
          return attrs;
        case "itSwitch":
          return attrs;
        case "itExtSwitch":
          return attrs;
        default:
          return attrs;
      }
    },
    getListeners() {
      const listeners = this.$listeners;
      const type = this.def.inputType.name.split(".").pop();
      switch (type) {
        case "itSelect":
          return listeners;
        case "itTreeSelect":
          return listeners;
        case "itMultiSelect":
          return listeners;
        case "itAutoComplete":
          if (
            this.def.lookup.lookupMethod?.name ===
            "ECore.Def.DefEnums.lmServerAutoComplete"
          )
            // return { ...listeners, keyup: () => this.inputLookup() };
            return { ...listeners, keyup: (e) => this.debounceInputLookup(e) };
          return listeners;
        case "itRiskIdSelector":
          if (
            this.def.lookup.lookupMethod?.name ===
            "ECore.Def.DefEnums.lmServerAutoComplete"
          )
            // return { ...listeners, keyup: () => this.inputLookup() };
            return { ...listeners, keyup: (e) => this.debounceInputLookup(e) };
          return listeners;
        case "itMultiAutoComplete":
          if (
            this.def.lookup.lookupMethod?.name ===
            "ECore.Def.DefEnums.lmServerAutoComplete"
          )
            return { ...listeners, keyup: (e) => this.debounceInputLookup(e) };
        case "itMultiCheckbox":
          return listeners;
        case "itMultiRadio":
          return listeners;
        case "itSwitch":
          return listeners;
        case "itExtSwitch":
          return listeners;
        default:
          return listeners;
      }
    },
    loopOverFormProps(def, payload) {
      if (!def) return null;
      if (def.pages) {
        return def.pages
          .flatMap((page) =>
            this.loopOverFormProps(page, payload).filter((prop) => prop),
          )
          ?.shift();
      }
      if (def.sections) {
        return def.sections.flatMap((section) =>
          this.loopOverFormProps(section, payload),
        );
      }
      if (def.panels) {
        return def.panels.flatMap((panel) =>
          this.loopOverFormProps(panel, payload),
        );
      }
      if (def.properties) {
        return def.properties.find((p) => p.origin?.name === payload)?.name;
      }
    },
    inputLookup(event) {
      //event
      const value = event.target.value;
      this.fetchLookupItems(value);
    },
    fillAdditional(payload, firstTime) {
      if (Array.isArray(payload)) return;
      const { additionalFields } = this.def.lookup;
      // console.log('fillAdditional additionalFields(',this.def.name,') :>> ' , payload ,firstTime , additionalFields ,this.Model );
      if (!payload) {
        additionalFields.forEach((additionalField) => {
          this.$set(this.Model, additionalField.name, undefined);
        });
        return;
      }
      const queryFields = JSON.parse(JSON.stringify(payload));
      delete queryFields.ID;
      delete queryFields.DisplayText;
      // console.log(this.def.name,' queryFields :>> ', queryFields);
      if (!Object.hasOwn(this.Model, "FullName")) {
        this.$set(this.Model, "FullName", undefined);
      }
      for (let key of additionalFields) {
        // console.log(this.def.name,'key :>> ', key , 'hasOwn :: ' , Object.hasOwn(this.Model, key.name) , ' qf :: ' , queryFields[key.name]);
        if (
          (Object.hasOwn(this.Model, key.name) && (queryFields[key.name]!=undefined)) ||
          (this.Model[key.name] !== queryFields[key.name] && !firstTime)
        ) {
          // console.log(this.def.name , ' ) ' , key.name , ' >>> ',this.Model?.validData[key.name]);
          if (
            this.Model?.validData == undefined ||
            this.Model?.validData?.[key.name] == undefined
          )
            this.$set(this.Model, key.name, queryFields[key.name]);
            // console.log(this.def.name , ' )  Model.' , key.name , ' >>> ',this.Model[key.name]);
        }
      }
    },
    ConvertToTree(list) {
      let temp = [];
      list.forEach((l) => {
        const pid = l.PID && `Folder@${l.PID}`;
        const id = `${l.Nodetype}@${l.ID}`;
        temp.push({
          PID: pid,
          OID: l.ID,
          ID: id,
          Nodetype: l.Nodetype,
          Label: l.Label,
        });
      });
      const map = temp.reduce((m, i) => Object.assign(m, { [i.ID]: i }), {});

      const root = [];

      const moveToParent = (node) => {
        if (node.PID && node.PID in map) {
          const parent = map[node.PID];
          if (!parent.children) parent.children = [];
          parent.children.push(node);
        } else {
          root.push(node);
        }
      };
      temp.forEach((i) => {
        moveToParent(i);
      });
      return root;
    },
    async fetchLookupItems(query, id) {
      const data = await this.$abr.api.fetchLookupData(
        this.def.lookup,
        this.filterValue || undefined,
        query,
        id,
      );

      this.lookupItems = [...data];

      if (this.def.lookupSettingExpr) {
        await this.$eval(this.def.lookupSettingExpr);
        return;
      }
      const currentSetting = this.$getProductInfo()
        ?.setting?.sections?.find((s) => s.name === "ControlParams")
        .params.flatMap((cs) => cs.nestedParams || cs);
      if (!currentSetting) return;
      currentSetting.forEach((param) => {
        if (
          param.lookup &&
          param.value?.json &&
          this.def.lookup.name === param.lookup.name
        )
          this.lookupItems = this.lookupItems.filter((val) =>
            JSON.parse(param.value?.json).includes(val.ID),
          );
      });

      // const getFromGrid = () => {
      //   const p = this.$getProductInfo()
      //   ?.setting?.sections?.find((s) => s.name === "ControlParams")
      //   .params.filter(p => p.paramType.name === "ECore.Def.DefEnums.ptEntityCollection").map(p => ({ value: p.value?.json, properties: p.entity?.properties }));
      //   p?.forEach(({ value, properties }) => {
      //     properties.forEach((param) => {
      //       if (param.lookup && value && this.def.lookup.name === param.lookup.name) {
      //         const parsedJSON = JSON.parse(value);
      //         console.log(parsedJSON);
      //         const a = parsedJSON.map(pj => pj[param.name]);
      //         console.log("this is lookup items fliter ====> ", this.def.name, param.name,this.lookupItems,  a);
      //         this.lookupItems = this.lookupItems.filter(val => a.flat().includes(val.ID));
      //       }
      //     })
      //   });

      // const param = this.$getProductInfo()
      // ?.setting?.sections?.find((s) => s.name === "ControlParams")
      // .params.find(p => p.name === "PolicyEndorse");
      // const json = JSON.parse(param.value.json)

      // //EndorseChangeListID
      // this.lookupItems = this.lookupItems.map(item => ({ ...item, CascadeValue: json.find(i => i.EndorseChangeList.includes(item.ID && i.EndorseType)) }))

      // //EndorseTypeID
      // this.lookupItems = this.lookupItems.filter(val => json.map(js => js.EndorseType).includes(val.ID))
    },
    normalizer(node) {
      return {
        id: node.ID && node.ID.replace("Leaf@", ""),
        label: node.Name || node.Label,
        children: node.children,
      };
    },
    // debounceServerLookupRequest(func, timeout = 1000) {
    //   let timer;
    //   return (...args) => {
    //     if (!timer) {
    //       func.apply(this, args);
    //     }
    //     clearTimeout(timer);
    //     timer = setTimeout(() => {
    //       timer = undefined;
    //     }, timeout);
    //   };
    // },
  },
};
</script>
<style>
red--text {
  color: red;
}
blue--text {
  color: blue;
}
</style>
